import { CUSTOM_LIST_INDEX_NAME } from './constants';
import normalizeOptionSku from './normalizeOptionSku';

const variantMatchesOptionSku = (product, optionSku) => {
  const wanted = normalizeOptionSku(optionSku);
  if (!wanted) {
    return false;
  }

  return (product.variants || []).some(variant => {
    const sku = normalizeOptionSku(variant.sku);
    return sku === wanted || sku.endsWith(wanted);
  });
};

const takeProduct = (pools, item) => {
  const pool = pools.get(item.productId);
  if (!pool?.length) {
    return null;
  }

  const matchedIndex = pool.findIndex(product =>
    variantMatchesOptionSku(product, item.optionSku)
  );
  const index = matchedIndex === -1 ? 0 : matchedIndex;
  const product = pool[index];

  if (pool.length === 1) {
    return product;
  }

  pool.splice(index, 1);
  return product;
};

const buildCustomListCards = ({
  items,
  products,
  queryID,
  indexName = CUSTOM_LIST_INDEX_NAME,
}) => {
  const pools = new Map();
  (products || []).forEach(product => {
    const productId = Number(product.id);
    const pool = pools.get(productId) || [];
    pool.push(product);
    pools.set(productId, pool);
  });

  const cards = (items || []).reduce((built, item) => {
    const product = takeProduct(pools, item);
    if (!product) {
      return built;
    }

    built.push({
      ...product,
      algoliaMetaData: {
        queryID: queryID || '',
        objectID: String(item.productId),
        indexName,
        position: item.hitPosition || 0,
      },
    });
    return built;
  }, []);

  const inStock = [];
  const outOfStock = [];
  cards.forEach(card => {
    if (card.variants?.[0]?.isOutOfStock) {
      outOfStock.push(card);
      return;
    }
    inStock.push(card);
  });

  return [...inStock, ...outOfStock].map((card, index) => ({
    ...card,
    position: index + 1,
  }));
};

export default buildCustomListCards;
